// third-party
import { Trans } from 'react-i18next';
// assets
import { IconBrandTwitch, IconDeviceAnalytics, IconReport, IconChartBar } from '@tabler/icons';

// constant
const icons = {
    IconBrandTwitch,
    IconChartBar,
    IconDeviceAnalytics,
    IconReport,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== /

const dashboard = {
    id: 'ticket',
    title: <Trans i18nKey="Suggestion box" id="ticket" />,
    type: 'group',
    children: [
        {
            id: 'complaints',
            title: <Trans i18nKey="Suggestion box" id="Suggestion box" />,
            type: 'item',
            url: '/complaints',
            icon: icons.IconBrandTwitch,
            breadcrumbs: false,
        },
        {
            id: 'report',
            title: <Trans i18nKey="Report" id="Report" />,
            type: 'collapse',
            url: '/report/by-year',
            icon: icons.IconChartBar,
            breadcrumbs: false,
            children: [
                {
                    id: 'by-year',
                    title: (
                        <>
                            <Trans i18nKey="By Year" id="By Year" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-year',
                    breadcrumbs: false,
                },
                {
                    id: 'by-month',
                    title: (
                        <>
                            <Trans i18nKey="By month" id="By month" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-month',
                    breadcrumbs: false,
                },
                {
                    id: 'by-store',
                    title: (
                        <>
                            <Trans i18nKey="By stores" id="By stores" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-stores',
                    breadcrumbs: false,
                },
                {
                    id: 'by-department',
                    title: (
                        <>
                            <Trans i18nKey="By department" id="By department" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-department',
                    breadcrumbs: false,
                },
                {
                    id: 'by-solution',
                    title: (
                        <>
                            <Trans i18nKey="By solution" id="By solution" />
                        </>
                    ),
                    type: 'item',
                    url: '/report/by-solution',
                    breadcrumbs: false,
                },
            ]
        },
    ]
};

export default dashboard;
